/* GG MOD START - FAQ & BreadcrumbList structured data (moved from GTM) */
(function () {
  /* === FAQPage Schema === */
  var details = document.querySelectorAll('details');
  if (details.length === 0) return;

  var faqs = [];
  details.forEach(function (item) {
    var summary = item.querySelector('summary');
    var answerDiv = item.querySelector('div');
    if (!summary || !answerDiv) return;

    var question = summary.textContent.trim();
    var answer = answerDiv.textContent.trim().replace(/\s+/g, ' ');

    if (question && answer) {
      faqs.push({
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer,
        },
      });
    }
  });

  if (faqs.length > 0) {
    var faqSchema = document.createElement('script');
    faqSchema.type = 'application/ld+json';
    faqSchema.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs,
    });
    document.head.appendChild(faqSchema);
  }

  /* === BreadcrumbList Schema === */
  var pageTitle = document.querySelector('h1');
  if (pageTitle) {
    var breadcrumbSchema = document.createElement('script');
    breadcrumbSchema.type = 'application/ld+json';
    breadcrumbSchema.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: window.location.origin,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: pageTitle.textContent.trim(),
          item: window.location.href.split('?')[0],
        },
      ],
    });
    document.head.appendChild(breadcrumbSchema);
  }
})();
/* GG MOD END */
